import { supabase } from '../lib/supabase';

export class AuditService {
  private bodyCorporateId: string;
  private userId: string;

  constructor(bodyCorporateId: string, userId: string) {
    this.bodyCorporateId = bodyCorporateId;
    this.userId = userId;
  }

  async logAction(
    action: 'CREATE' | 'UPDATE' | 'DELETE' | 'REVERSE' | 'LOGIN' | 'LOGOUT',
    entityType: string,
    entityId: string,
    oldData?: any,
    newData?: any
  ) {
    try {
      const { error } = await supabase
        .from('audit_logs')
        .insert({
          body_corporate_id: this.bodyCorporateId,
          user_id: this.userId,
          action: action,
          entity_type: entityType,
          entity_id: entityId,
          old_data: oldData,
          new_data: newData,
          created_at: new Date().toISOString(),
        });
      if (error) throw error;
    } catch (error) {
      console.error('Error logging audit action:', error);
    }
  }

  async getAuditTrail(
    filters?: {
      entityType?: string;
      entityId?: string;
      userId?: string;
      fromDate?: string;
      toDate?: string;
    }
  ) {
    let query = supabase
      .from('audit_logs')
      .select(`
        *,
        profiles (full_name, email)
      `)
      .eq('body_corporate_id', this.bodyCorporateId)
      .order('created_at', { ascending: false });

    if (filters?.entityType) {
      query = query.eq('entity_type', filters.entityType);
    }
    if (filters?.entityId) {
      query = query.eq('entity_id', filters.entityId);
    }
    if (filters?.userId) {
      query = query.eq('user_id', filters.userId);
    }
    if (filters?.fromDate) {
      query = query.gte('created_at', filters.fromDate);
    }
    if (filters?.toDate) {
      query = query.lte('created_at', filters.toDate);
    }

    const { data, error } = await query;

    if (error) {
      console.error('Error fetching audit trail:', error);
      return [];
    }

    return data || [];
  }

  async getEntityHistory(entityType: string, entityId: string) {
    return this.getAuditTrail({ entityType, entityId });
  }

  async getRecentActivity(limit: number = 50) {
    const { data, error } = await supabase
      .from('audit_logs')
      .select(`
        *,
        profiles (full_name, email)
      `)
      .eq('body_corporate_id', this.bodyCorporateId)
      .order('created_at', { ascending: false })
      .limit(limit);

    if (error) {
      console.error('Error fetching recent activity:', error);
      return [];
    }

    return data || [];
  }
}

export default AuditService;
